import { Col } from 'antd';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';
import { locationInfoMessages } from './locationDisplay.utils';

export const PointOutOfGridInfo = () => {
  return (
    <Col span={12}>
      <div className={styles.depthGridContainer}>
        <div className={styles.InfoCol}>
          <Label
            label={locationInfoMessages.waterDepth}
            className={styles.InfoColLabelUnavailable}
          />
          <Label
            label={locationInfoMessages.gridCellSize}
            className={styles.InfoColLabelRightUnavailable}
          />
        </div>
        <div className={styles.additionalInfoText}>
          {locationInfoMessages.pointOutOfGrid}
        </div>
      </div>
    </Col>
  );
};
